import React, { useEffect, useState } from "react";
import Navbar from "../Components/Navbar";
import Footer from "../Components/Footer";
import img from "../Assets/modal.png";
import heart from "../Assets/hear.png";
import redHeart from "../Assets/redHeart.png";
import { apiGet, apiPost, calculateAge, Get_Api } from "../ApiUrls";
import ContentLoader from 'react-content-loader';
import serch from '../Assets/Vector.png'
import { toast } from "react-toastify";
import { useNavigate } from "react-router-dom";
import x from '../Assets/39753-removebg-preview.png'
import hearts from '../Assets/heart-icon.png'
import star from '../Assets/9344450.png'
import personicon from '../Assets/Mask group.png'
import cam from '../Assets/camera-svgrepo-com (2) 2.png'
import SEOData from "../Components/SEOData";
function AllModal() {
  const navigate = useNavigate()
  const [AllModels, setAllModels] = useState([]);
  const [IsUploading, setIsUploading] = useState(true);

  const [IsLogin, setsetIsLogin] = useState(false);

  useEffect(() => {
    const dataToken = localStorage.getItem("userToken");
    if (dataToken) {
      setsetIsLogin(true);
    } else {
      setsetIsLogin(false);
    }
  }, []);

  const [IsUser, setIsUser] = useState(false);
  const [IsHostess, setIsHostess] = useState(false);

  useEffect(() => {
    const userType = JSON.parse(localStorage.getItem("userType"));

    if (userType === "User") {
      setIsUser(true);
    }
    if (userType === "Hostess") {
      setIsHostess(true);
    }
  }, []);

  const [UserProfile, setUserProfile] = useState({});


  const GetUserProfile = async () => {
    try {
      const response = await apiGet(`api/user/GetUserProfile`);
      setUserProfile(response?.data);
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    if (IsLogin) {
      if (IsUser) {
        GetUserProfile();
      }
    }
  }, [IsLogin,]);

  const [City, setCity] = useState('');
  const [State, setState] = useState('');
  const [AvailableFor, setAvailableFor] = useState([]);
  const [PersonalityorHobbies, setPersonalityorHobbies] = useState([]);
  const [gender, setgender] = useState("");

  const handleGenderSelection = (selectedGender) => {
    setgender(gender === selectedGender ? "" : selectedGender);
  };


  const [allStateCity, setAllStateCity] = useState([]);

  const getAllStateCity = async () => {
    const Country = localStorage.getItem("Country") || "India";
    try {
      setIsUploading(true);
      const response = await Get_Api(`api/admin/GetAllStateCity?country=${Country}`);
      setAllStateCity(response.data || []);
      setIsUploading(false);
    } catch (error) {
      console.error('Error fetching data:', error);
    }
  };

  useEffect(() => {
    getAllStateCity();
  }, []);



  const GetAllHostess = async () => {
    try {
      setIsUploading(true);
      const queryParams = new URLSearchParams();

      if (State) queryParams.append("State", State);
      if (City) queryParams.append("City", City);
      if (UserProfile) {
        const selectedGender = gender || (UserProfile?.Gender === "Male" ? "Female" : "Male");
        queryParams.append("Gender", selectedGender);
      }
      if (AvailableFor?.length > 0) queryParams.append("AvailableFor", AvailableFor);
      // if (PersonalityorHobbies?.length > 0) queryParams.append("PersonalityorHobbies", PersonalityorHobbies);

      const response = await apiGet(`api/user/GetAllHostess?${queryParams.toString()}`);
      setAllModels(response?.data);
      setIsUploading(false);
    } catch (error) {
      setIsUploading(false);
      console.log(error);
    }
  };

  useEffect(() => {
    GetAllHostess();
  }, [City, AvailableFor, gender, UserProfile]);


  const LikeHostess = async (id) => {
    try {
      if (!IsLogin) {
        navigate('/login')
        return toast.success("Please Login as User");
      }
      if (!IsUser) {
        return toast.success("Please Login as User");
      }
      const response = await apiPost(`api/user/LikeHostess/${id}`);
      GetUserProfile();
      toast.success(response?.message);
    } catch (error) {
      toast.success(error?.response?.message);
      console.log(error);
    }
  };

  const ModelDetailPage = (id) => {
    navigate(`/ModelDetail/${id}`)
    window.scrollTo({ top: 0, behavior: "smooth" });
  }

  const [AllAvailableFor, setAllAvailableFor] = useState([]);
  const [AllPersonalityorHobbies, setAllPersonalityorHobbies] = useState([]);

  const GetAvailableFor = async () => {
    try {
      setIsUploading(true);
      const response = await Get_Api(`api/admin/GetAllAvailableFor`);
      setAllAvailableFor(response?.data);
      setIsUploading(false);
    } catch (error) {
      setIsUploading(false);
      console.log(error);
    }
  };

  const GetallHobby = async () => {
    try {
      setIsUploading(true);
      const response = await Get_Api(`api/admin/GetAllHobby`);
      setAllPersonalityorHobbies(response?.data);
      setIsUploading(false);
    } catch (error) {
      setIsUploading(false);
      console.log(error);
    }
  };

  useEffect(() => {
    GetAvailableFor();
    // GetallHobby();
  }, []);


  const [ShowFilter, setShowFilter] = useState(false);

  const OpenCloseFilter = () => {
    setShowFilter(!ShowFilter)
  }

  const [ShowAvailablefor, setShowAvailablefor] = useState(false);

  const OpenCloseAvailablefor = () => {
    setShowAvailablefor(!ShowAvailablefor)
  }

  const [ShowHobby, setShowHobby] = useState(false);

  const OpenCloseHobby = () => {
    setShowHobby(!ShowHobby)
  }
  const [ShowGender, setShowGender] = useState(false);

  const OpenCloseGender = () => {
    setShowGender(!ShowGender)
  }

  const [Cities, setCities] = useState([]);

  const handleStateChange = (e) => {
    const StateTitle = e.target.value;
    setState(StateTitle);

    const stateObj = allStateCity?.find((state) => state.Title === StateTitle);

    if (stateObj) {
      setCities(stateObj.City || []);
    } else {
      setCities([]);
    }
  };

  const handleSelection = (name, type) => {
    if (type === "AvailableFor") {
      setAvailableFor((prev) =>
        prev.includes(name) ? prev.filter((item) => item !== name) : [...prev, name]
      );
    } else if (type === "PersonalityorHobbies") {
      setPersonalityorHobbies((prev) =>
        prev.includes(name) ? prev.filter((item) => item !== name) : [...prev, name]
      );
    }
  };


  return (
    <>
      <Navbar />
      <SEOData PageName={'allmodal'} />
      <div className="login-form-left0">
        <div className="ChatList">
          <div className="ChatList-search">
            <select
              value={State}
              onChange={handleStateChange}
            >
              <option value="" disabled>Select State</option>
              {allStateCity?.map((state, index) => (
                <option key={index} value={state.Title}>{state.Title}</option>
              ))}
            </select>
            <img onClick={() => { GetAllHostess() }} src={serch} />
          </div>

        </div>

      </div>
      {State &&
        <div className="modal-fliter">
          {Cities?.map((city, index) => (
            <div
              className={`modal-fliter-tab ${City === city ? 'selected' : ''}`}
              key={index}
              onClick={() => setCity(city)}
            >
              <img src={cam} />
              <p>{city}</p>
            </div>
          ))}
        </div>
      }
      <div className="modal-fliter">
        <div className="modal-fliter-tab modal-fliter-tab2" onClick={OpenCloseFilter}>
          <i class="bi bi-filter-left"></i>
          <p>Filter</p>
        </div>
        {
          ShowFilter &&
          <div className="modal-fliter-tab" onClick={OpenCloseAvailablefor}>
            <img src={cam} />
            <p>Available For</p>
          </div>
        }
        {/* {
          ShowFilter &&
          <div className="modal-fliter-tab" onClick={OpenCloseHobby}>
            <img src={cam} />
            <p>Hobby</p>
          </div>
        } */}
        {
          ShowFilter &&
          <div className="modal-fliter-tab" onClick={OpenCloseGender}>
            <img src={cam} />
            <p>Gender</p>
          </div>
        }
      </div>
      {ShowAvailablefor && ShowFilter &&
        <div className="modal-fliter">
          {AllAvailableFor?.map((item) => (
            <div
              className={`modal-fliter-tab ${AvailableFor.includes(item.Name) ? 'selected' : ''}`}
              key={item._id}
              onClick={() => handleSelection(item.Name, "AvailableFor")}
            >
              <img src={item.Image} alt={item.Name} />
              <p>{item.Name}</p>
            </div>
          ))}
        </div>
      }
      {ShowHobby && ShowFilter &&
        <div className="modal-fliter">
          {AllPersonalityorHobbies?.map((item) => (
            <div
              className={`modal-fliter-tab ${PersonalityorHobbies.includes(item.Name) ? 'selected' : ''}`}
              key={item._id}
              onClick={() => handleSelection(item?.Name, "PersonalityorHobbies")}
            >
              <img src={cam} />
              <p>{item.Name}</p>
            </div>
          ))}
        </div>
      }
      {ShowGender && ShowFilter && (
        <div className="modal-fliter">
          <div
            className={`modal-fliter-tab ${gender === "Male" ? "selected" : ""}`}
            onClick={() => handleGenderSelection("Male")}
          >
            <img src={cam} />
            <p>Male</p>
          </div>
          <div
            className={`modal-fliter-tab ${gender === "Female" ? "selected" : ""}`}
            onClick={() => handleGenderSelection("Female")}
          >
            <img src={cam} />
            <p>Female</p>
          </div>
        </div>
      )}
      <div className="modal-cards">
        {IsUploading ? (
          <ContentLoader viewBox="0 0 820 450" height={'100%'} width={'100%'}>
            <rect x="10" y="10" rx="5" ry="5" width="260" height="280" />
            <rect x="280" y="10" rx="5" ry="5" width="260" height="280" />
            <rect x="550" y="10" rx="5" ry="5" width="260" height="280" />
            <rect x="10" y="160" rx="5" ry="5" width="260" height="280" />
            <rect x="280" y="300" rx="5" ry="5" width="260" height="280" />
            <rect x="550" y="160" rx="5" ry="5" width="260" height="280" />
          </ContentLoader>
        ) : (
          AllModels?.map((item, index) => {
            const IsLiked = UserProfile?.LikedHostess?.includes(item?._id);
            return (
              <div onClick={() => { ModelDetailPage(item?._id) }} className="modal-card2" key={index}>
                <div onClick={() => { LikeHostess(item?._id) }} style={{ cursor: "pointer" }}>
                  <img className="heart" src={IsLiked ? redHeart : heart} alt="Favorite" />
                </div>
                <img src={item?.ProfileImage ? item?.ProfileImage : img} alt="Model" />
                <div className="modal-card-text">
                  <h3>{item?.UserName || 'Karine'}</h3>
                  {/* <p>{item?.DOB ? `${calculateAge(item?.DOB)} Years Old` : '22 Years Old'}</p> */}
                </div>
              </div>
            )
          })
        )}
      </div>
      <div className="center">
        <button>View More</button>
      </div>
      <Footer />
    </>
  );
}

export default AllModal;
